import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { Observer, Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class UploadService {
  constructor(private dataService: DataService) {
  }
  url = environment.api_base_url;

  uploadFile(formData: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.post(this.url + "dataentry/upload", formData).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getUploadMissingData(formData: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "dataentry/upload?date=" + formData).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  refreshDataSet(): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.post(this.url + "dataentry/upload/refresh-data-sets", null).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

}